module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "error-page-container"
  }, [_c('img', {
    staticClass: "left-part",
    attrs: {
      "src": "static/img/404.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right-part"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("抱歉，您访问的链接地址有误，请重新查找或刷新页面试一试！")]), _vm._v(" "), _c('el-button', {
    staticClass: "back-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b016496","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 545
// module chunks = 0